import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-6 bg-navy overflow-hidden" data-id="element-100">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/[0.03] rounded-full blur-3xl pointer-events-none" data-id="element-101" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-102">
        {/* Prominent Logo */}
        <FadeIn data-id="element-103">
          <div className="relative flex justify-center mb-10" data-id="element-104">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 md:w-64 md:h-64 bg-gold/[0.07] rounded-full blur-2xl pointer-events-none" data-id="element-105" />
            <motion.img src="https://cdn.magicpatterns.com/uploads/8iq9FdZPWhhg1moFGMfStg/Gemini_Generated_Image_vohteevohteevoht_(1)-Photoroom.png" alt="Oscar Rodriguez" className="relative z-10 w-40 md:w-56 lg:w-64 object-contain drop-shadow-[0_0_30px_rgba(201,168,76,0.25)]" initial={{
            scale: 0.8,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            duration: 0.5,
            ease: [0.25, 0.1, 0.25, 1]
          }} data-id="element-106" />
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-107">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold text-white leading-tight mb-8" data-id="element-108">
            El problema no es tu equipo… <br className="hidden md:block" data-id="element-109" />
            <span className="text-gold/90" data-id="element-110">
              es el caos operativo de tu negocio
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-111">
          <p className="text-xl md:text-2xl text-gray-light font-sans mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-112">
            Si tu empresa se siente desordenada, pesada y difícil de sostener,
            necesitas estructura, no más esfuerzo.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-113">
          <p className="text-lg text-gray-light/80 font-sans mb-12 max-w-2xl mx-auto" data-id="element-114">
            Te ayudo a ordenar tu operación con estrategia, ingeniería y
            tecnología aplicada.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-115">
          <div className="flex flex-col items-center gap-4" data-id="element-116">
            <a href="#agenda" className="inline-block bg-gold hover:bg-yellow-500 text-navy font-bold text-lg px-8 py-4 rounded transition-all duration-300 hover:scale-105 shadow-[0_0_20px_rgba(201,168,76,0.3)]" data-id="element-117">
              Agenda un diagnóstico estratégico
            </a>
            <p className="text-sm text-gray-light/60 max-w-md text-center mt-2" data-id="element-118">
              Para dueños de negocio que ya tienen operación, pero sienten que
              el desorden les está quitando control.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}